import Language from "./Language";
import Message from "./Message";
import File from "./File";
import { formatDate } from "../utils/format-utils";
import Provider from "./Provider";

export default class Appointment {
  mtaAppointmentId: number | null;
  idepClientId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  dateOfBirth?: Date | null;
  streetAddress?: string | null;
  streetAddressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  phoneNumber?: string | null;
  canReceiveText?: boolean | null;
  emailAddress?: string | null;
  otherLanguageId?: number | null;
  otherLanguage?: Language | null;
  appointmentRequestedAt?: Date | null;
  appointmentDate?: Date | null;
  appointmentTime?: string | null;
  comments?: string | null;
  cancelledAt?: Date | null;
  lastNotificationSentAt?: Date | null;
  confirmedAt?: Date | null;
  status?: string | null;
  messages?: Message[] | null;
  arrivalTime?: string | null;
  endTime?: string | null;
  assessorId?: number | null;
  assessor?: Provider | null;
  recommendation?: string | null;
  idepExpirationDate?: Date | null;
  files?: File[] | null;

  public constructor(params: Appointment = {} as Appointment) {
    let {
      mtaAppointmentId = 0,
      idepClientId = "",
      firstName = "",
      lastName = "",
      dateOfBirth = null,
      streetAddress = "",
      streetAddressLine2 = "",
      city = "",
      state = "",
      zipCode = "",
      phoneNumber = "",
      canReceiveText = false,
      emailAddress = "",
      otherLanguageId = null,
      otherLanguage = null,
      appointmentRequestedAt = null,
      appointmentDate = null,
      appointmentTime = null,
      comments = "",
      cancelledAt = null,
      status = "",
      lastNotificationSentAt = null,
      confirmedAt = null,
      messages = [],
      arrivalTime = null,
      endTime = null,
      assessorId = null,
      assessor = null,
      recommendation = null,
      idepExpirationDate = null,
      files = [],
    } = params;

    this.mtaAppointmentId = mtaAppointmentId;
    this.idepClientId = idepClientId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.dateOfBirth = dateOfBirth;
    this.streetAddress = streetAddress;
    this.streetAddressLine2 = streetAddressLine2;
    this.city = city;
    this.state = state;
    this.zipCode = zipCode;
    this.phoneNumber = phoneNumber;
    this.canReceiveText = canReceiveText;
    this.emailAddress = emailAddress;
    this.otherLanguageId = otherLanguageId;
    this.otherLanguage = otherLanguage && new Language(otherLanguage);
    this.appointmentRequestedAt = appointmentRequestedAt;
    this.appointmentDate = appointmentDate;
    this.appointmentTime = appointmentTime;
    this.comments = comments;
    this.cancelledAt = cancelledAt;
    this.lastNotificationSentAt = lastNotificationSentAt;
    this.confirmedAt = confirmedAt;
    this.status = status;
    this.messages = messages && messages.map((item) => new Message(item));
    this.arrivalTime = arrivalTime;
    this.endTime = endTime;
    this.assessorId = assessorId;
    this.assessor = assessor && new Provider(assessor);
    this.recommendation = recommendation;
    this.idepExpirationDate = idepExpirationDate;
    this.files = files && files.map((item) => new File(item));;
  }

  get fullName() {
    return this.firstName + " " + this.lastName;
  }

  get appointmentDateNoTime() {
    return (
      this.appointmentDate &&
      new Date(this.appointmentDate).setHours(0, 0, 0, 0)
    );
  }

  get formattedAppointmentDate() {
    return formatDate(this.appointmentDateNoTime);
  }

  get formattedAppointmentTime() {
    if (this.appointmentTime) {
      const [hours, minutes] = this.appointmentTime.split(":").map(Number);
      const ampm = hours >= 12 ? "PM" : "AM";
      const hours12 = hours % 12 || 12;
      return `${hours12.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")} ${ampm}`;
    }
    return "";
  }

  get statusColor() {
    switch (this.status) {
      case "Scheduled":
        return "accent";
      case "Confirmed":
        return "secondary";
      case "Completed":
        return "success";
      case "Cancelled":
      case "No Show":
      default:
        return "#808080";
    }
  }
}
